import linda from "../assets/linda.png";
import jennyImg from "../assets/Jenny.webp";
import aseracare from "../assets/pdvimages/aseracare.svg";
import harborlight from "../assets/pdvimages/harborlight.svg";
import tabitha from "../assets/pdvimages/tabitha.svg";
import housecall from "../assets/pdvimages/housecall.svg";
import hopehospice from "../assets/pdvimages/hopehospice.svg";
import ecumen from "../assets/pdvimages/ecumen.svg";
import guardian from "../assets/pdvimages/guardian.svg";
import alina from "../assets/pdvimages/alina.svg";
import northfield from "../assets/pdvimages/northfield.svg";
import peacehealth from "../assets/pdvimages/peacehealth.svg";
import pennyroyal from "../assets/pdvimages/pennyroyal.svg";
import townsquare from "../assets/pdvimages/townsquare.svg";
import snowline from "../assets/pdvimages/snowline.svg";
import interim from "../assets/pdvimages/interim.svg";
import sholom from "../assets/pdvimages/sholom.svg";
import accentcare from "../assets/pdvimages/accentcare.svg";
import bythebay from "../assets/pdvimages/bythebay.svg";
import partners from "../assets/pdvimages/partners.svg";
import santacruzcounty from "../assets/pdvimages/santacruzcounty.svg";
import kindred from "../assets/pdvimages/kindred.svg";
import integration from "../assets/pdvimages/integration.svg";
import intelligent from "../assets/pdvimages/intelligent.svg";
import forms from "../assets/pdvimages/forms.svg";
import location from "../assets/pdvimages/location.svg";
import document from "../assets/pdvimages/document.svg";
import communications from "../assets/pdvimages/communications.svg";
import volunteerassociation_1 from "../assets/pdvimages/elderly-person-being-taken-care-by-female-caretaker.webp";
import volunteerassociation_2 from "../assets/pdvimages/woman-with-laptop-knee-chatting.webp";
import security from "../assets/pdvimages/security.svg";
import collaboration from "../assets/pdvimages/collaboration.svg";
import innovation from "../assets/pdvimages/innovation.svg";
import compassion from "../assets/pdvimages/compassion.svg";
import provenExperience from "../assets/pdvimages/provenExperience.svg";
import supportiveCommunity from "../assets/pdvimages/supportiveCommunity.svg";
import comprehensiveSolution from "../assets/pdvimages/comprehensiveSolution.svg";

export const carouseldata = [
  {
    id: 1,
    image: linda,
    role: "Volunteer Coordinator - AccentCare",
    name: "Anne Myers",
    description:
      "There are so many advantages to using PDV. It makes communication more timely, easier to read, and is less expensive than printing, mailing, and filing paper forms.Compliance with volunteer documentation increased using the PDV .We were also able to fill volunteer requests for our patients more easily and more quickly with the PDV.",
  },
  {
    id: 2,
    image: jennyImg,
    role: "Manager of Volunteer Services - Snowline Health",
    name: "Jodie Regan",
    description:
      "The PDV has saved countless hours for our administrative teams. I have found the customer service to be stellar. The Help Desk typically sends a solution to any issue within a couple of hours, if not sooner.The volunteers have been able to access their assignments and submit their reports any time and from anywhere. PDV has been a mainstay in our Volunteer Department",
  },
];

export const hospicesIcons = [
  aseracare,
  harborlight,
  tabitha,
  housecall,
  hopehospice,
  ecumen,
  guardian,
  alina,
  northfield,
  peacehealth,
  pennyroyal,
  kindred,
  townsquare,
  snowline,
  interim,
  sholom,
  accentcare,
  bythebay,
  partners,
  santacruzcounty,
];

export const pdvIcons = [
  {
    icon: integration,
    title: "Integration",
    alt:"Integration with existing EHR",
    decscription:
      "Integrates easily with your existing EHRs, eliminating the need for double data entry",
  },
  {
    icon: forms,
    title: "Comprehensive Forms Library ",
    alt:"Comprehensive Forms Library",
    decscription:
      "The PDV Forms Library has the latest  collection of forms for every type of  hospice volunteer task",
  },
  {
    icon: location,
    title: "Accurate Volunteer Hour Tracking",
    alt:"PDV Accurate Volunteer Hour Tracking",
    decscription:
      "Effortlessly monitor and record volunteer hours with our intuitive tracking system",
  },
  {
    icon: document,
    title: "Easy Documentation & Compliance",
    alt:"Easy Documentation & Compliance as per HIPAA standards",
    decscription:
      "Simplifies documentation and ensures compliance with regulations through streamlined forms and automated processes",
  },
  {
    icon: communications,
    title: "Efficient Communications",
    alt:"Efficient Communications between volunteers and hospice coordinators",
    decscription:
      "Communicate with hospice volunteers efficiently and in compliance with HIPAA",
  },
  {
    icon: intelligent,
    title: "Intelligent Assistants",
    alt:"Intelligent Assistants for volunteers and coordinators",
    decscription:
      "Assists in providing personalized care for patients & makes everyday tasks easier",
  },
];

export const volunteerAssociations = [
  {
    img: volunteerassociation_1,
    title: "Explore HVA",
    alt:"Volunteer providing care to hospice patient",
    link: "https://ihva.org/",
  },
  {
    img: volunteerassociation_2,
    title: "Members Login",
    alt:"Hospice volunteer coordinator",
    link: "https://ihva.org/?goToLogin=true",
  },
];

export const values = [
  {
    icon: compassion,
    title: "Compassion",
    alt:"Compassion",
    decscription:
      "We prioritize the needs and dignity of patients and their families",
  },
  {
    icon: security,
    title: "Security",
    alt:"Security", 
    decscription:
      "We are committed to maintaining the highest standards of data protection and privacy",
  },
  {
    icon: innovation,
    title: "Innovation",
    alt:"Innovation",
    decscription:
      "We continuously improve our systems to better serve the hospice community",
  },
  {
    icon: collaboration,
    title: "Collaboration",
    alt:"Collaboration",
    decscription:
      "We work closely with volunteers, managers, and healthcare professionals to meet their needs",
  },
];

export const choosePdvIcons = [
  {
    icon: comprehensiveSolution,
    title: "Comprehensive Solution",
    alt:"Comprehensive Solution for volunteer management",
    decscription:
      "A robust system that covers all aspects of volunteer program management",
  },
  {
    icon: provenExperience,
    title: "Proven Experience",
    alt:"Proven Experience in hospice volunteer tools",
    decscription:
      "Over a decade of expertise in managing sensitive patient data",
  },
  {
    icon: supportiveCommunity,
    title: "Supportive Community",
    alt:"Supportive Community for volunteers",
    decscription:
      "Backed by the HVA and a network of compassionate volunteers and managers",
  },
];

export const referralOptions = [
  { value: "Google", label: "Google" },
  { value: "Yahoo", label: "Yahoo" },
  { value: "HEAL Project Website", label: "HEAL Project Website" },
  {
    value: "Hospice Volunteer Association Website",
    label: "Hospice Volunteer Association Website",
  },
  { value: "HVA e-mail", label: "HVA e-mail" },
  { value: "Volunteer Coordinator", label: "Volunteer Coordinator" },
  { value: "Friend or Colleague", label: "Friend or Colleague" },
  { value: "Hospice Community Forum", label: "Hospice Community Forum" },
  { value: "Others", label: "Other (Please, Specify Below)" },
];

export const aboutUsEventTimeLine=[

    {
        id: 1,
        year: 1999,
        title: "The Hospice Educators Affirming Life (HEAL) Project",
        colorId: "#FEF9D9C9",
        description:
          "Founded in 1999 by Greg Schneider as a 501(c)(3) non-profit to provide education and support for end-of-life care and promote hospice volunteerism. Greg went on to develop three additional initiatives to further support the hospice community",
      },
      {
        id: 2,
        year: 2005,
        title: "HOSPICE VOLUNTEER ASSOCIATION (HVA)",
        colorId: "#FADFA1B2",
        description:
          "The recognized organization in the U.S. representing hospice volunteers and managers providing training and educational resources. Current membership is 10,000 members",
      },
      {
        id: 3,
        year: 2008,
        title: "PATIENT DATA VAULT (PDV)",
        colorId: "#BBE9FF",
        description:
          "Hospice Volunteer Program Management Software. Since 2008 we have served 88 hospice offices nationwide. Used by over 8000 hospice volunteers and managers",
      },
      {
        id: 4,
        year: 2009,
        title: "HOSPICE COMMUNITY FORUM (HCF)",
        colorId: "#CDC1FF96",
        description:
          "An online community forum that facilitates communication and professional development within the hospice community. Current membership 2,000 members",
      },
    
]

export const hippaPoints = [
    {
      id: 1,
      description:
        "For hospices, maintaining the privacy of patient information while using electronic communications is a significant challenge. The U.S.Department of Health and Human Services (HHS) established the Standards for Privacy of Individually Identifiable Health. Information, known as the Privacy Rule, under the Health Insurance Portability and Accountability Act (HIPAA). These national standards protect certain health information and ensure compliance with federal guidelines",
    },
    {
      id: 2,
      description:
        "If your hospice relies on conventional email, with or without file attachments, to communicate sensitive information between volunteer coordinators (VC) and volunteers, it's important to note that these methods do not meet the required Privacy Rule standards.",
    },
    {
      id: 3,
      description:
        "The Privacy Rule governs the use and disclosure of protected health information (PHI) by covered entities, while also safeguarding individuals' rights to understand and control how their health information is utilized. The Rule's primary goal is to ensure the proper protection of PHI, while allowing necessary information flow to support high-quality healthcare and public health initiatives.",
    },
    {
      id: 4,
      description:
        "Recognizing the diversity of the healthcare marketplace, the Privacy Rule is designed to be both flexible and comprehensive, enabling essential information use while safeguarding patient privacy. For hospices, this means adopting communication tools and practices that align with these stringent privacy standards.",
    },
  ];
  